import { z } from 'zod';

export const crossPanelSchema = z.object({
  text: z.string().min(1),
  portCount: z.number().min(0).int(),
  location: z.string(),
});

export type CrossPanelSchema = z.infer<typeof crossPanelSchema>;
